import { render } from "preact";
import { useEffect } from "preact/hooks";
import { LocationProvider, Router, Route, useLocation } from "preact-iso";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/signal.css";
import "./styles/motion.css";
import { TabBar } from "./components/TabBar";
import { applyTheme } from "./lib/theme";
import { Today } from "./screens/Today";
import { Week } from "./screens/Week";
import { Routes, RouteCard } from "./screens/Routes";
import { Rides, RideCard } from "./screens/Rides";
import { Paris, NotYet } from "./screens/Paris";
import { Racing } from "./screens/Racing";
import { boot } from "./lib/store";
import { SignIn } from "./screens/SignIn";
import { Weight } from "./screens/Weight";
import { Coach } from "./screens/Coach";
import { Privacy } from "./screens/Privacy";
import { Mallorca, Tour } from "./screens/Books";
import { You } from "./screens/You";
import { Review } from "./screens/Review";
import { AddRoute } from "./screens/AddRoute";
import { Explore } from "./screens/Explore";

function Shell() {
  const { path } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [path]);
  return (
    <>
      <Router>
        <Route path="/" component={Today} />
        <Route path="/week" component={Week} />
        <Route path="/rides" component={Rides} />
        <Route path="/rides/:id" component={RideCard} />
        <Route path="/routes" component={Routes} />
        <Route path="/routes/add" component={AddRoute} />
        <Route path="/routes/new" component={Explore} />
        <Route path="/routes/:id" component={RouteCard} />
        <Route path="/paris" component={Paris} />
        <Route path="/racing" component={Racing} />
        <Route path="/signin" component={SignIn} />
        <Route path="/coach" component={Coach} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/mallorca" component={Mallorca} />
        <Route path="/tour" component={Tour} />
        <Route path="/weight" component={Weight} />
        <Route path="/you" component={You} />
        <Route path="/review" component={Review} />
        <Route default component={() => <NotYet title="Not here" line="That page does not exist yet." />} />
      </Router>
      {path !== "/signin" && <TabBar />}
    </>
  );
}

applyTheme();
render(<LocationProvider><Shell /></LocationProvider>, document.getElementById("app")!);
boot();
// Back to the app after a while away: read again, and pull any new Strava rides.
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") boot(); });

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register("/sw.js").catch(() => { /* offline shell is a nicety, not a requirement */ });
}
